export default "__VITE_ASSET__CkN$szn1__"